import React from 'react';
import { connect } from 'react-redux';

const BankId = () => <h2>Not implemented</h2>;

export default connect()(BankId);
